// src/pages/Pedidos.jsx
import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Paper,
  Box,
  Fab,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import api from "../services/api"; // <-- adicionamos integração real

export default function Pedidos() {
  const navigate = useNavigate();

  const [isAdmin, setIsAdmin] = useState(false);
  const [tab, setTab] = useState(0);

  const [naoTransmitidos, setNaoTransmitidos] = useState([]);
  const [transmitidos, setTransmitidos] = useState([]);
  const [loading, setLoading] = useState(true);

  // ======================
  // Verifica se é ADMIN
  // ======================
  useEffect(() => {
    const adm = localStorage.getItem("administrador");
    setIsAdmin(adm === "S" || adm === "true");
  }, []);

  // ======================
  // Carrega dados reais da API
  // ======================
  useEffect(() => {
    carregarPedidos();
  }, []);

  const carregarPedidos = async () => {
    try {
      setLoading(true);

      // pega pedidos reais
      const resp = await api.get("/pedido");
      const pedidos = resp.data || [];

      const nao = pedidos
        .filter((p) => p.Transmitido === "N")
        .map((p) => ({
          id: p.Numero,
          cliente: p.Cliente_Nome,
          total: p.Valor,
          data: new Date(p.Data).toLocaleDateString("pt-BR"),
        }));

      const trans = pedidos
        .filter((p) => p.Transmitido === "S")
        .map((p) => ({
          id: p.Numero,
          cliente: p.Cliente_Nome,
          total: p.Valor,
          data: new Date(p.Data).toLocaleDateString("pt-BR"),
        }));

      setNaoTransmitidos(nao);
      setTransmitidos(trans);
    } catch (e) {
      console.error("Erro ao carregar pedidos", e);
    } finally {
      setLoading(false);
    }
  };

  // ======================
  // Render do bloco de pedidos
  // ======================
  const renderLista = (lista) => (
    <Paper sx={{ p: 2, mt: 2 }}>
      {lista.length === 0 ? (
        <Typography color="gray">Nenhum pedido encontrado.</Typography>
      ) : (
        lista.map((p) => (
          <Box
            key={p.id}
            sx={{
              p: 2,
              mb: 1,
              border: "1px solid #ddd",
              borderRadius: "10px",
              cursor: "pointer",
              "&:hover": { background: "#f5f5f5" },
            }}
            onClick={() => navigate(`/pedidos/${p.id}`)}
          >
            <Typography variant="subtitle1">
              <b>Cliente:</b> {p.cliente}
            </Typography>
            <Typography variant="body2">
              <b>Data:</b> {p.data}
            </Typography>
            <Typography variant="body2">
              <b>Total:</b> R$ {p.total}
            </Typography>
          </Box>
        ))
      )}
    </Paper>
  );

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" mb={2}>
        Pedidos
      </Typography>

      {/* Tabs: Transmitidos / Não Transmitidos */}
      <Tabs value={tab} onChange={(e, v) => setTab(v)}>
        <Tab label="Não Transmitidos" />
        <Tab label="Transmitidos" />
      </Tabs>

      {loading ? (
        <Box textAlign="center" mt={5}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {tab === 0 && renderLista(naoTransmitidos)}
          {tab === 1 && renderLista(transmitidos)}
        </>
      )}

      {/* BOTÃO FLUTUANTE PARA NOVO PEDIDO */}
      <Fab
        color="primary"
        sx={{
          position: "fixed",
          bottom: 30,
          right: 30,
          backgroundColor: "#0088CC",
        }}
        onClick={() => navigate("/pedidos/novo")}
      >
        <AddIcon />
      </Fab>
    </Container>
  );
}
